import {
  faChevronSquareDown,
  faChevronSquareUp,
} from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Field } from "formik";
import React, { useState } from "react";
import { FieldInputDollar, FieldInputPercentage } from "../../../components";
import {
  CalculateProrationForSourceAllocation,
  CalculateProrationSplitUp,
  DeductProratedSplits,
  calculateEffectiveSourceWithdrawal,
  calculateTotalVestedBalanceFromSourceBalance,
  calculationToBeBasedOnGrossAmount,
  feeAndTaxesModel,
  getValues,
  getVestedBalanceWithoutVestingMultiplier,
  isAllowMeToChooseTransaction,
  isFederalTaxApplicable,
  isRolloverDistributionMode,
  taxCalculationForGrossForEachSource,
  taxCalculationForNetForEachSource,
  withdrawalTypeEnum,
} from "./DistributionConstantsAndFunctions";
export const AddTreeStructureEditable = (props) => {
  const {
    handleChange,
    values,
    fields,
    grossAmountEffective,
    requestedAmountEffective,
    shouldDisplayPenalty,
    outerValues,
    filteredSourceBalances,
  } = props;
  const totalFeeEffective =
    getValues(values[fields.eftFee]) +
    getValues(values[fields.checkFee]) +
    getValues(values[fields.rollOverFee]);
  const feeAndTaxes = feeAndTaxesModel(values);
  const grossAmountAfterFeeDeduction = grossAmountEffective - totalFeeEffective;
  console.log("values6777", values);
  const effectiveSourceWithdrawal = calculateEffectiveSourceWithdrawal(
    {
      ...values,
      [fields.requestedAmount]:
        values[fields.requestedAmount] ?? values[fields.grossAmount],
    },
    outerValues,
    filteredSourceBalances
  );
  console.log(
    "effectiveSourceWithdrawal",
    effectiveSourceWithdrawal,
    filteredSourceBalances,
    getVestedBalanceWithoutVestingMultiplier(effectiveSourceWithdrawal)
  );
  const effectiveSourceWithdrawalWithoutFee = DeductProratedSplits(
    effectiveSourceWithdrawal,
    CalculateProrationSplitUp(
      effectiveSourceWithdrawal,
      totalFeeEffective,
      [],
      false
    )
  );
  const totalTaxSplitEffective = DeductProratedSplits(
    effectiveSourceWithdrawalWithoutFee,
    effectiveSourceWithdrawalWithoutFee.map((source) =>
      taxCalculationForNetForEachSource(source, feeAndTaxes)
    )
  );
  const totalTaxOnly = DeductProratedSplits(
    effectiveSourceWithdrawalWithoutFee,
    effectiveSourceWithdrawalWithoutFee.map((source) =>
      taxCalculationForNetForEachSource(source, feeAndTaxes, true, false)
    )
  );
  const totalPenaltyOnly = DeductProratedSplits(
    effectiveSourceWithdrawalWithoutFee,
    effectiveSourceWithdrawalWithoutFee.map((source) =>
      taxCalculationForNetForEachSource(source, feeAndTaxes, false, true)
    )
  );
  console.log("totalTaxEffective", totalTaxSplitEffective);
  console.log(
    "totalTaxEffective",
    getVestedBalanceWithoutVestingMultiplier(totalTaxSplitEffective),
    getVestedBalanceWithoutVestingMultiplier(totalTaxOnly),
    getVestedBalanceWithoutVestingMultiplier(totalPenaltyOnly)
  );
  const totalTaxEffective = getVestedBalanceWithoutVestingMultiplier(
    totalTaxSplitEffective
  );
  const checkOrEFTFee =
    values[fields.paymentMethod] === 2
      ? [
          {
            name: "EFT fee",
            columnName: fields.eftFee,
          },
        ]
      : values[fields.paymentMethod] === 1
      ? [
          {
            name: "Check fee",
            columnName: fields.checkFee,
          },
        ]
      : [];
  const rollOverFee =
    [
      withdrawalTypeEnum.Inservice,
      withdrawalTypeEnum.SeparationFromService,
    ].includes(outerValues[fields.withdrawalType]) &&
    isRolloverDistributionMode(values[fields.distributionMode])
      ? [
          {
            name: "Rollover fee",
            columnName: fields.rollOverFee,
          },
        ]
      : [];
  const taxAndFeesStructure = [
    {
      head: "Tax Deduction",
      columnName: "Tax",
      amount: getValues(
        getVestedBalanceWithoutVestingMultiplier(totalTaxOnly)
      ).toFixed(2),
      subHead: isFederalTaxApplicable(outerValues)
        ? [
            {
              name: "State tax",
              columnName: fields.stateTax,
            },
            {
              name: "Federal tax",
              columnName: fields.federalTax,
            },
          ]
        : [
            {
              name: "State tax",
              columnName: fields.stateTax,
            },
          ],
    },
    {
      head: "Fee deduction",
      columnName: "Fee",
      amount: totalFeeEffective.toFixed(2),
      subHead: [...checkOrEFTFee, ...rollOverFee],
    },
    {
      head: "Penalty",
      columnName: "Penalty",
      amount: getValues(
        getVestedBalanceWithoutVestingMultiplier(totalPenaltyOnly)
      ).toFixed(2),
      subHead:
        values[fields.waiveOffLimitApplicable] === true
          ? [
              {
                name: "Waive off percentage",
                columnName: fields.waiveOffLimit,
              },
            ]
          : [
              {
                name: "Early withdrawal penalty",
                columnName: fields.earlyWithdrawalPenalty,
              },
            ],
    },
  ].filter((_) => shouldDisplayPenalty || _.columnName !== "Penalty");
  // useDeepEffect(() => {
  //   setOpen(
  //     taxAndFeesStructure.map((_) => {
  //       return false;
  //     })
  //   );
  // }, [taxAndFeesStructure]);

  const [isOpen, setOpen] = useState([
    ...taxAndFeesStructure.map((_) => {
      return false;
    }),
  ]);
  return (
    <ul className="tree">
      {taxAndFeesStructure?.map((item, index) => {
        return (
          <>
            <li>
              <div
                style={{
                  fontSize: "16px",
                  fontWeight: "400",
                  marginLeft: "-25px",
                  color: "#307BF6",
                }}
              >
                <FontAwesomeIcon
                  className="mr-2"
                  onClick={() =>
                    setOpen(
                      isOpen.map((data, i) => {
                        if (i == index) {
                          return !data;
                        }
                        return data;
                      })
                    )
                  }
                  icon={isOpen[index] ? faChevronSquareUp : faChevronSquareDown}
                />

                {item.head}
              </div>
              <div
                style={{
                  fontSize: "16px",
                  float: "right",
                  marginTop: "-30px",
                  marginRight: "-35px",
                }}
              >
                ${item?.amount}
              </div>
              {isOpen[index] && (
                <ul className="ml-0">
                  {item.subHead?.map((subHead, index) => {
                    return (
                      <li style={{ justifyContent: "space-between" }}>
                        <div style={{ marginLeft: "-25px" }}>
                          {subHead.name}
                        </div>
                        <div
                          style={{
                            float: "right",
                            marginTop: "-30px",
                            marginRight: "-40px",
                            color: "#646464",
                            marginRight: "-75px",
                          }}
                        >
                          {item.columnName === "Penalty" ? (
                            `${getValues(values[subHead.columnName])} %`
                          ) : item.columnName === "Tax" ? (
                            <Field
                              value={values[subHead.columnName]}
                              name={subHead.columnName}
                              onChange={handleChange}
                              min={0}
                              max={subHead.columnName === "stateTax" ? 50 : 30}
                              size="xs"
                              component={FieldInputPercentage}
                            />
                          ) : (
                            <Field
                              name={subHead.columnName}
                              value={values[subHead.columnName]}
                              onChange={handleChange}
                              size="xs"
                              preventNegative={true}
                              component={FieldInputDollar}
                            />
                          )}
                        </div>
                      </li>
                    );
                  })}
                </ul>
              )}
            </li>
            {index !== taxAndFeesStructure.length - 1 && <hr />}
          </>
        );
      })}
    </ul>
  );
};
